import React from 'react'
import RepeatableSection from './RepeatableSection'
import Form from './Form'
import { FlatDomainDataContext, FormBean, IUIRepeatableFormDef} from '../../datatypes'

interface RepeatableFormProps {
    metadata:IUIRepeatableFormDef;
    formBean:FormBean;
    ctx:FlatDomainDataContext;
}

export default class RepeatableForm extends React.Component<RepeatableFormProps,{}> {

  render() {
    return (
      <Form {...this.props} className="repeatableForm" useChildren={true}>
        <RepeatableSection {...this.props}/>
      </Form>
    )
  }
}